import {
    type DependencyList,
    type Dispatch,
    type SetStateAction,
    useEffect,
    useState,
} from "react";

/**
 * Much like useState, but updates the value automatically when initialValue is changed.
 * @param initialValue Initial value
 * @param depGraph useEffect dependency graph. May need to specify if having infinite loop issues.
 * @returns [value, setValue dispatch]
 */
export function useActiveState<T>(
    initialValue: T | (() => T),
    depGraph?: DependencyList
): [T, Dispatch<SetStateAction<T>>] {
    const [value, setValue] = useState<T>(initialValue);

    useEffect(() => {
        // console.log("value", initialValue);
        setValue(initialValue);
    }, depGraph ?? [initialValue]);

    return [value, setValue];
}
